import { ClientDataService, IClientDataDoc } from '../../../services/clientData.service'

export class QuickActionsService extends ClientDataService {
  private QUICK_ACTIONS_DOC = 'tb_mdc_quick'
  private QUICK_ACTIONS_BUTTONS_DOC = 'tb_mdc_quick_buttons'

  async getQuickActions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.QUICK_ACTIONS_DOC)
  }

  async getQuickActionButtons(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.QUICK_ACTIONS_BUTTONS_DOC)
  }
}
